import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

import { BasedataService } from '../shared/basedata.service';

import { Pools, Pool } from './pool';
import { ConfigService } from '@docma-mm-core/config/config.service';

@Injectable()
export class PoolService extends BasedataService {

  private projectUrl: string = '/projects/';
  private poolUrl: string = '/pools';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  // for get and post methods
  private getProjectPoolUrl(projectId: number) {
    return super.getFullUrl(this.projectUrl + projectId + this.poolUrl);
  }

  // for put and delete methods
  private getPoolUrl() {
    return super.getFullUrl(this.poolUrl);
  }

  // get project pools
  getPools(projectId: number, top: number = 10000, skip: number = 0): Observable<Pools> {
    let endpoint = this.getProjectPoolUrl(projectId);
    let httpParams = new HttpParams();
    if (top) httpParams = httpParams.set('$top', top.toString());
    if (skip) httpParams = httpParams.set('$skip', skip.toString());
    httpParams = httpParams.set('$details', 10);
    return this.http
      .get<Pools>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // create new project pool
  createPool(projectId: number, pool: Pool): Observable<Pool> {
    let endpoint = this.getProjectPoolUrl(projectId);
    return this.http
      .post<Pool>(endpoint, JSON.stringify(pool), { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // update existing pool
  updatePool(poolId: number, pool: Pool): Observable<Pool> {
    let endpoint = this.getPoolUrl() + '/' + poolId;
    return this.http
      .put<Pool>(endpoint, JSON.stringify(pool), { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // delete pool
  deletePool(poolId: number): Observable<any> {
    let endpoint = this.getPoolUrl() + '/' + poolId;
    return this.http
      .delete<any>(endpoint, { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

}
